'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.yearFromNow;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/number/yearFromNow.js
// module id = 760
// module chunks = 0